import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '../api';
import { endpoints } from '../endpoints';

import type { TBenchmarkingResponse } from './types';

export type GetInsightsRequest = {
  start: Date;
  end: Date;
  priorStart: Date;
  priorEnd: Date;
  shouldUseMockData?: boolean;
};

export const useGetBenchmarkingInsightsData = (options: GetInsightsRequest) => {
  const { start, end, priorStart, priorEnd, shouldUseMockData } = options;
  const { primaryOrganizationId: organizationId } = useSelector(
    (state: any) => state.login.user,
  );

  return useQuery<TBenchmarkingResponse>({
    queryKey: [
      'benchmarks',
      organizationId,
      start,
      end,
      priorStart,
      priorEnd,
      shouldUseMockData,
    ],
    queryFn: async () => {
      const response = await makeAPIRequestReactQuery<TBenchmarkingResponse>(
        `/${endpoints.videaInsights}/${organizationId}/benchmarks`,
        {
          start,
          end,
          priorStart,
          priorEnd,
          returnSampleResponse: shouldUseMockData,
        },
        'get',
        {
          headers: {
            Org: organizationId,
          },
        },
      );

      return response;
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  });
};
